import { formatDate } from "@progress/kendo-intl";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { useGetSessions } from "../../../apiclient/master/useGetSessionApi";
import { SelectField } from "../../../core/select-field.component";
import { Form, Formik } from "formik";
import { API_END_POINT } from "../../../constants";
import { getDataWithToken, getEndPoint, getHtmlWithToken, getPDFWithToken } from "../../../Utils/network.client";
import axios from "axios";
import { Button } from "react-bootstrap";
const html2pdf = require("html2pdf.js");

interface IPrepareIndentReport { }

interface RouteAbstract {
  [key: string]: any; // Adjust based on actual API response
}

interface DispatchedStatus {
  [key: string]: boolean; // Define the expected structure
}

interface RouteAbs {
  routeabstract: RouteAbstract[];
  routeabstractheader: any[];
  routedetails: any[];
}

interface ParsedData {
  routeabs: RouteAbs[];
  totalabs?: any; // Add other properties as needed
}

export const PrepareIndentReport: React.FC = () => {
  const [reportMenu, setReportMenu] = useState<IPrepareIndentReport[]>([]);
  const [sessionData, setSessionData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedSession } = useGetSessions();
  const [dispatchedStatus, setDispatchedStatus] = useState<DispatchedStatus>({});

  useEffect(() => { }, [reportMenu]);

  const [parsedData, setParsedData] = useState<ParsedData | null>(null);
  const [totalabstractdetail, settotalabstractdetail] = useState([]);
  const [totalabstractcolumns, settotalabstractColumns] = useState([]);
  const [totalabstractgridData, settotalabstractGridData] = useState([]);
  const [sessionid, setSessionId] = useState([]);
  const [routeid, setRouteId] = useState([]);
  const [selectedDay, setSelectedDay] = useState<string>("");

  // Get today's date and tomorrow's date for day picker
  const today = dayjs().format("YYYY-MM-DD"); // Today's date
  const tomorrow = dayjs().add(1, "day").format("YYYY-MM-DD"); // Tomorrow's date

  useEffect(() => {
    if (fetchedSession) {
      const mappedSession = fetchedSession
      .filter((session: any) => session.name.trim().toLowerCase() !== "both") 
      .map((session: any) => ({
        value: session.sessionId,
        label: session.name,
      }));
      setSessionData(mappedSession);
    }

  }, [fetchedSession]);


  // Initial values for Formik
  const initialValues = {
    sessionId: "", // default empty value for zone
    selectedDay: selectedDay,
  };

  const oldindent = async () => {
    try {

      const response = await getDataWithToken<any>(
                      `${getEndPoint(API_END_POINT.REPORT)}/api/TotalAbstract/GetTotalAbstractByDateShift/${dayjs(selectedDay).format("YYYY-MM-DD")}/${sessionid}`
                  );

      // const response = await getDataWithToken<any>(
      //                 `${getEndPoint(API_END_POINT.REPORT)}/api/TotalAbstract/GetTotalAbstractByDateShift/2024-03-/${sessionid}`
      //             );

      console.log(response.data);

      const parsedResponse = JSON.parse(response.data.result);;
      setParsedData(parsedResponse);

      if(parsedResponse.totalabs.totaldetails != null ) 
      {
        const totalabstractdetails = parsedResponse.totalabs.totaldetails;
        settotalabstractdetail(totalabstractdetails);
  
        const columnHeaders: string[] = Object.values(parsedResponse.totalabs.totalabstractheader[0]) as string[];
        settotalabstractColumns(columnHeaders);
  
         
          const transformedData = parsedResponse.totalabs.totalabstract.map((row: Record<string, any>, index: number) => {
            let newRow: Record<string, any> = {};
            Object.keys(row).forEach((key, index) => {
              newRow[columnHeaders[index]] = row[key]; // Now TypeScript knows columnHeaders[index] is a string
            });
            return newRow;
          });
          settotalabstractGridData(transformedData);
        
      } else {
        console.error("No Records");
      }
      

    } catch (error) {
      console.error("Error fetching data:", error);
      throw error; // Re-throwing in case you need to handle it outside
    }
  };

  const fetchPdfData = async (routeId: string) => {
    try {
            
      const response1 = await getDataWithToken<any>(
        `${getEndPoint(API_END_POINT.REPORT)}/api/PrepareIndent/SaveGatePass/${dayjs(selectedDay).format("YYYY-MM-DD")}/${sessionid}/${routeId}`
    );

    //   const response1 = await getDataWithToken<any>(
    //     `${getEndPoint(API_END_POINT.REPORT)}/api/PrepareIndent/SaveGatePass/2024-08-01/${sessionid}/${routeId}`
    // );

      // const response1 = await axios.get(apiUrl1);

      console.log(response1.data);

      if (response1.data === 1) {
       

         const response = await getPDFWithToken(
                        `${getEndPoint(API_END_POINT.REPORT)}/api/OldIndent/GenerateIndentPdf/${dayjs(selectedDay).format("YYYY-MM-DD")}/${sessionid}/${routeId}`
                    );

            // const response = await getPDFWithToken(
            //             `${getEndPoint(API_END_POINT.REPORT)}/api/OldIndent/GenerateIndentPdf/2024-08-01/${sessionid}/${routeId}`
            //         );

         // Create a downloadable link
         const url = window.URL.createObjectURL(response);
         const link = document.createElement("a");
         link.href = url;
         link.setAttribute("download", "GatePass_DeliveryNote.pdf");
         document.body.appendChild(link);
         link.click();
         
         // Clean up
         document.body.removeChild(link);
         window.URL.revokeObjectURL(url);

        setDispatchedStatus((prevStatus) => ({
          ...prevStatus,
          [routeId]: true,
        }));

        alert("Indent Prepared!");
      }
    } catch (error) {
      console.error("Error fetching route data:", error);
    }
  };


  
  const handleSessionChange = (value: any) => {
    setSessionId(value);
    console.log("Sessionid id is:", sessionid);
  };

  const handleRouteChange = (value: any) => {
    setRouteId(value);
    console.log("Route id is:", routeid);
  };

   const fetchHtmlAndConvertToPdf = async (routeId: string) => {
          try {

            const response1 = await getDataWithToken<any>(
              `${getEndPoint(API_END_POINT.REPORT)}/api/PrepareIndent/SaveGatePass/${dayjs(selectedDay).format("YYYY-MM-DD")}/${sessionid}/${routeId}`
          );
      
          //   const response1 = await getDataWithToken<any>(
          //     `${getEndPoint(API_END_POINT.REPORT)}/api/PrepareIndent/SaveGatePass/2024-08-01/${sessionid}/${routeId}`
          // );
      
            // const response1 = await axios.get(apiUrl1);
      
            console.log(response1.data);
      
            if (response1.data === 1) {
              const apiUrl = `${getEndPoint(API_END_POINT.REPORT)}/api/OldIndent/GenerateIndentPdf/${dayjs(selectedDay).format("YYYY-MM-DD")}/${sessionid}/${routeId}`;
              
              const htmlContent = await getHtmlWithToken(apiUrl);
      
              // Convert HTML string to a temporary div element
              const tempDiv = document.createElement("div");
              tempDiv.innerHTML = htmlContent;
              document.body.appendChild(tempDiv);
      
              // Convert HTML to PDF using html2pdf
              html2pdf()
                  .from(tempDiv)
                  .set({
                      margin: 10,
                      filename: "GatePass_DeliveryNote.pdf",
                      image: { type: "jpeg", quality: 1 },
                      html2canvas: {  backgroundColor: null,scale: 1, useCORS: true },
                      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
                  })
                  .save()
                  .then(() => {
                      // Clean up after PDF is saved
                      document.body.removeChild(tempDiv);
                  });
                }
          } catch (error) {
              console.error("Error fetching HTML and converting to PDF:", error);
          }
      };


  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log("Form submitted with values: ", values);
      }}
    >
      {({ setFieldValue, values }) => (
        <Form>

          <div
            className="m-lg-3 mt-lg-1 m-4 card p-3 border-0 m-3 sw-shadow radius-15"
            style={{ minHeight: "500px" }}
          >
            <div className="top-sec-align row">
              <center>
                <h4 className="text-normal title-web mb-0 report-title-color">Prepare Indent</h4>
              </center>
            </div>
            <div className="fade_rule"></div>
            <div className="d-flex justify-content-between mt-4 pt-3 pb-3">

              <div className="d-flex">
                <div className="me-2">
                  <label>Select Day</label>
                  {/* <DatePicker
                    showMonthYearPicker
                    className="form-control ms-auto search-right-align calendarBg"
                    selected={toDate}
                    dateFormat="MMMM yyyy" // Displays month as text (e.g., "January 2024")
                    onChange={(date: Date) => setToDate(date)}
                    placeholderText="Select Month & Year"
                  /> */}

                  <select
                    name="selectedDay"
                    className="form-control"
                    value={selectedDay}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedDay(value);
                      setFieldValue("selectedDay", value); // Update Formik value
                    }}
                  >
                    <option value="" disabled>
                      --Select Day--
                    </option>
                    <option value={today}>Today</option>
                    <option value={tomorrow}>Tomorrow</option>
                  </select>
                </div>

                <div className="me-2">
                  <label> Select Session </label>
                  <SelectField
                    name="sessionId"
                    options={sessionData}
                    unSelectValue={0}
                    notifyChange={handleSessionChange}
                  />
                </div>


                <div>
                  <label></label>
                  <button
                    className="btn-primary btn search-btn mt-4"
                    onClick={() => {
                      oldindent()
                    }}
                    type="submit"
                  >
                    <svg width="17" height="17" viewBox="0 0 17.5 17.5">
                      <path
                        id="Path_magnify"
                        data-name="Path / magnify"
                        d="M9.5,3a6.5,6.5,0,0,1,4.94,10.73l.27.27h.79l5,5L19,20.5l-5-5v-.79l-.27-.27A6.5,6.5,0,1,1,9.5,3m0,2A4.5,4.5,0,1,0,14,9.5,4.481,4.481,0,0,0,9.5,5Z"
                        transform="translate(-3 -3)"
                        fill="#fff"
                      />
                    </svg>
                  </button>
                </div>

              </div>
            </div>
            <div className="row col=12">
              <div>
                <LoadingIndicator isLoading={false} />
                {totalabstractdetail.length > 0 && (
                  <div>


                    <div style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "start",
                      padding: "5px 10px",
                      gap: "350px" // Adjust spacing between columns if needed
                    }}>

                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <h6 className="text-muted">Orders:</h6>
                        <p style={{ fontSize: "14px", lineHeight: "1" }}>
                          Milk: <strong>{totalabstractdetail[0].milk}L</strong>
                        </p>
                        <p style={{ fontSize: "14px", lineHeight: "1" }}>
                          Fermented: <strong>{totalabstractdetail[0].fermented}L</strong>
                        </p>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <h6 className="text-muted">Routes:</h6>
                        <p style={{ fontSize: "14px", lineHeight: "1" }}>
                          All: <strong>{totalabstractdetail[0].activeroutes}</strong>
                        </p>
                        <p style={{ fontSize: "14px", lineHeight: "1" }}>
                          Has Order: <strong>{totalabstractdetail[0].orderedroutes}</strong>
                        </p>
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                        <h6 className="text-muted">Business:</h6>
                        <p style={{ fontSize: "14px", lineHeight: "1" }}>
                          Active: <strong>{totalabstractdetail[0].activecustomer}</strong>
                        </p>
                        <p style={{ fontSize: "14px", lineHeight: "1" }}>
                          Ordered: <strong>{totalabstractdetail[0].orderedcustomer}</strong>
                        </p>
                      </div>

                      {/* <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                                                <Button>
                                                    Download
                                                </Button>
                                            </div> */}
                    </div>

                  </div>
                )}

              </div>
            </div>
            <div style={{ padding: "20px", backgroundColor: "#fff" }}>

              {totalabstractgridData.length > 0 && totalabstractcolumns.length > 0 ? (

                <Grid data={totalabstractgridData} style={{ height: "auto", width: "auto" }}>
                  {totalabstractcolumns
                    .map((col, index) => (
                      <GridColumn key={index} field={col} title={index === 0 ? "CATEGORY" : col} width="95px" className={index === 0 ? "text-start" : "text-end"} />
                    ))}
                </Grid>
              ) : (
                <p>No data available</p>
              )}
            </div>
            <div style={{ padding: "10px", backgroundColor: "#fff" }}>
              {parsedData && parsedData.routeabs != null && parsedData.routeabs.map((route: RouteAbs, index: number) => {
                console.log(`Route ${index + 1} Data:`, route);
                console.log("Route Abstract:", route.routeabstract);

                return (
                  <div key={index} style={{ marginBottom: "20px" }}>
                    {/* <h5>Route {index + 1}</h5> */}

                    {route.routedetails && route.routedetails.length > 0 && route.routedetails.map((detail, detailIndex) => (
                      <div key={detailIndex} style={{ padding: "2px", width: "auto", backgroundColor: "#f8f9fa" }}>
                        <div style={{
                          display: "flex",
                          justifyContent: "space-around",
                          alignItems: "start",
                          padding: "5px 10px",
                          gap: "20px" // Adjust spacing between columns if needed
                        }}>
                          {/* Left Column: Route and Date */}
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <p style={{ fontSize: "14px", lineHeight: "1" }}>
                              Route:<strong> {detail.rname}</strong>
                            </p>
                            <p style={{ fontSize: "14px", lineHeight: "1" }}>
                              Date: <strong>{detail.orderdate}</strong>
                            </p>
                          </div>

                          {/* Right Column: Active Businesses and Ordered Businesses */}
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                            <p style={{ fontSize: "14px", lineHeight: "1" }}>
                              Active Businesses:<strong> {detail.activecustomer}</strong>
                            </p>
                            <p style={{ fontSize: "14px", lineHeight: "1" }}>
                              Ordered Businesses: <strong>{detail.orderedcustomer}</strong>
                            </p>
                          </div>
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                          <Button onClick={() => fetchHtmlAndConvertToPdf(detail.rid)}>
                  {detail.isdespatched || dispatchedStatus[detail.rid] ? "Download" : "Close & Prepare"}
                </Button>
                          </div>

                        </div>

                      </div>
                    ))}

                    {route.routeabstract && Array.isArray(route.routeabstract) && route.routeabstract.length > 0 ? (
                      <Grid data={route.routeabstract} style={{ height: "auto", width: "auto" }}>
                        {Object.entries(route.routeabstractheader[0])
                          .slice(1)
                          .map(([key, value], colIndex) => (
                            <GridColumn
                              key={colIndex}
                              field={key} // Keep the key for mapping data
                              title={colIndex === 0 ? "CATEGORY" : String(value)} // Use the actual column name
                              width={"95px"}
                              className={colIndex === 0 || colIndex === 1 ? "text-start" : "text-end"}
                            />
                          ))}

                        {/* {routescolumns
                                                    .map((col, index) => (
                                                        <GridColumn key={index} field={col} title={col} width="95px" className={index === 0 ? "text-start" : "text-end"} />
                                                    ))} */}
                      </Grid>
                    ) : (
                      <p></p>
                    )}
                  </div>
                );
              })}
            </div>


          </div>
        </Form>
      )
      }
    </Formik >
  );
};
